import TianDingDateYearMonthComponent from "./dateYearMonth.vue";

export default {
  install(Vue, PluginOptions = {}) {
    const Constructor = Vue.extend(TianDingDateYearMonthComponent);
    Vue.component('td-date-year-month', Constructor);
  }
}



// WEBPACK FOOTER //
// ./src/_components/dateYearMonth/index.js